import { useMemo } from "react";

import { Plug } from "components/icons/generated";
import useIsFlowsAacIntegrationEnabled from "hooks/useIsFlowsAacIntegrationEnabled";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useIntegrateServicesGroup = (): MainNavigationItem => {
  const isFlowsAacIntegrationEnabled = useIsFlowsAacIntegrationEnabled();

  return useMemo(
    () => ({
      id: "integrate-services",
      title: "Integrate Services",
      icon: Plug,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Integrations],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Plugins],
            ...(isFlowsAacIntegrationEnabled
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Flows]]
              : []),
          ],
        },
      ],
    }),
    [isFlowsAacIntegrationEnabled]
  );
};

export default useIntegrateServicesGroup;
